module.exports = __webpack_public_path__ + "static/media/how_algae_could_transform_diets_article.7cfca9ba.jpg";